import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Box, Grid, Hidden } from "@material-ui/core";
import Submit from "../../components/Submit";
import { useTranslation } from "react-i18next";
import ContactView from "../../views/account/ContactView";

const ContactsForm = ({ onSubmit = () => {}, initialValues, isInstaller }) => {
  const shapeYup = {
    telephone_number: Yup.string().required("Is required"),
    cellular_number: Yup.string().required("Is required"),
  };
  if (isInstaller) {
    shapeYup["vat_number"] = Yup.string().required("Is required");
  }
  const validationSchema = Yup.object().shape({
    telephone_number: Yup.string().required("Is required"),
    cellular_number: Yup.string().required("Is required"),
  });

  const { t } = useTranslation();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(props) => (
        <form onSubmit={props.handleSubmit}>
          <Box
            mt={1}
            boxShadow={{ xs: 0, sm: 2 }}
            display="flex"
            flexDirection="column"
            p={2}
          >
            <ContactView installer={isInstaller} {...props} />
            <Box mt={2}>
              <Grid container spacing={2}>
                <Hidden xsDown>
                  <Grid item sm={10}></Grid>
                </Hidden>
                <Grid item xs={12} sm={2}>
                  <Submit {...props} title={t("register.button_save")} />
                </Grid>
              </Grid>
            </Box>
          </Box>
        </form>
      )}
    </Formik>
  );
};

export default ContactsForm;
